module.exports = __webpack_public_path__ + "img/tech.921e7278.svg";